import { PeekGrid, PeekList, PeekListItem, PeekListItemButton, PeekListItemText, PeekPaper, PeekTypography, useTheme, } from "@piiqtechnologies/ui-components";
import React from "react";
export function MagicButtonTemplateSelector({ templates, onSelect, selectedTemplate, }) {
    const theme = useTheme();
    return (React.createElement(PeekGrid, null,
        React.createElement(PeekTypography, { variant: "h4" }, "Template"),
        React.createElement(PeekPaper, { sx: { mt: 1 } },
            React.createElement(PeekList, { sx: {
                    border: `1px solid ${(selectedTemplate && theme.palette.success.main) || "transparent"}`,
                    borderRadius: theme.spacing(0.5),
                } }, templates.map((template) => (React.createElement(PeekListItem, { backgroundColor: theme.palette.success.light, selected: template._id === (selectedTemplate === null || selectedTemplate === void 0 ? void 0 : selectedTemplate._id), key: template._id },
                React.createElement(PeekListItemButton, { onClick: () => onSelect(template), dense: true },
                    React.createElement(PeekListItemText, { primary: template.templateName, primaryTypographyProps: { variant: "body1" } })))))))));
}
